module.exports = __webpack_public_path__ + "img/question13c1.bc7b0efe.png";